module.exports = __webpack_public_path__ + "files/5a80bcf0baea73da089bcfc7d1b1ae17.png";